import { render, staticRenderFns } from "./RLogoIconHR.vue?vue&type=template&id=fca2271a&scoped=true"
import script from "./RLogoIconHR.vue?vue&type=script&lang=ts"
export * from "./RLogoIconHR.vue?vue&type=script&lang=ts"
import style0 from "./RLogoIconHR.vue?vue&type=style&index=0&id=fca2271a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca2271a",
  null
  
)

export default component.exports